export const amountParser = (number?: number, precision?: number) => {
  return number?.toFixed(precision ?? 2).replace('.', ',')
}
